
import { Component, Mixins } from 'vue-property-decorator'
import { API_URLS } from '@/utils/helpers'
import axios from 'axios'
import PromotionRecommendation from './templates/PromotionRecommendation.vue'
import OverviewPage from './templates/OverviewPage.vue'
import FundingResult from './templates/FundingResult.vue'
import MapMixin from '@/components/showcase_generator/MapMixin.vue'
import GoogleMapLoader from '@/components/GoogleMapLoader.vue'
import MapPlaceholder from '@/components/MapPlaceholder.vue'
import { IPublicShowcasePage } from '@/types/showcase'
import { isArray } from 'lodash'

@Component({
  components: {
    PromotionRecommendation,
    OverviewPage,
    FundingResult,
    MapPlaceholder,
    GoogleMapLoader
  }
})
export default class PublicShowcase extends Mixins(MapMixin) {
  showcasePage: IPublicShowcasePage = null
  showMap = false

  get containerClass (): string {
    let containerClass = 'showcase-detail-page'
    if (!this.isWidget) {
      containerClass += ' container'
    }
    if (this.isSelectedTemplate('promotion_recommendation_default')) {
      containerClass += ' promotion-recommendation-detail-page'
    } else if (this.isSelectedTemplate('funding_result_default')) {
      containerClass += ' funding-result-detail-page'
    } else if (this.isSelectedTemplate('funding_request_default')) {
      containerClass += ' funding-request-detail-page'
    }
    return containerClass
  }

  get isWidget (): boolean {
    return this.$route.path.endsWith("/widget/")
  }

  get isPromotionRecommendation (): boolean {
    return this.showcasePage?.template.category === 1
  }

  get isFundingResult (): boolean {
    return this.showcasePage?.template.category === 2
  }

  get isOverviewPage (): boolean {
    return this.showcasePage?.template.category === 3
  }

  isSelectedTemplate (templateName: string): boolean {
    return this.showcasePage?.template?.category?.toString() === templateName
  }

  setPageTitle (title: string): void {
    document.title = title
  }

  isPreview (): boolean {
    return !!this.$route.query?.preview_token
  }

  mounted (): void {
    this.$wait.start('load showcasepage')
    let url = API_URLS.SHOWCASE_PAGE.PUBLIC(this.$route.params.slug)
    if (this.isPreview()) {
      const previewToken = isArray(this.$route.query.preview_token) ? this.$route.query.preview_token[0] : this.$route.query.preview_token
      url = API_URLS.SHOWCASE_PAGE.PREVIEW(this.$route.params.slug, previewToken)
    }
    axios.get(url).then(response => {
      this.showcasePage = response.data
      this.setPageTitle(this.showcasePage.title)
      this.$wait.end('load showcasepage')
    })
  }
}
